export default {
  // 小数点格式转换（参数1: 值，参数2:保留几位小数 ）
  pointFormat(val, point = 2) {
    if (val === 0 || !val) return Number(0).toFixed(point);
    if (typeof val !== "number") val = Number(val);
    if (typeof point !== "number" || point < 0) {
      throw new Error("保留位数参数配置不正确，保留位数不能小于0");
    }
    const divisor = Math.pow(10, point);
    return (Math.round(val * divisor) / divisor).toFixed(point);
  },
};
